import {
    IResourceBarrierPFD,
    IResourceBarrierStatus,
    IResourceThreatStatus,
    IEscalationFactorQualitativeBarriers,
    IMandatoryBarriers,
    IManualInteractionBarrierStatus,
    IRiskAcceptance
} from 'plugin-codaf-risk-ext-bowtie/types/reports'

export const riskAcceptance: IRiskAcceptance[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        bowtieName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        riskLevelStatus: 'Intolerable',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        bowtieName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        riskLevelStatus: 'Intolerable',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const resourceThreatStatus: IResourceThreatStatus[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        threatName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        inherentRisk: '3.18e-4',
        residualRisk: '3.18e-4',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        threatName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        inherentRisk: '3.18e-4',
        residualRisk: '3.18e-4',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const resourceBarrierStatus: IResourceBarrierStatus[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        type: 'Prevention',
        entityName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        category: 'Training and Competency ',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        type: 'Prevention',
        entityName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        category: 'Training and Competency ',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const resourceBarrierPFDs: IResourceBarrierPFD[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        initialPFD: '3.18e-4',
        finalPFD: '3.18e-4',
        threshold: '3.18e-4',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        initialPFD: '3.18e-4',
        finalPFD: '3.18e-4',
        threshold: '3.18e-4',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const manualInteractionBarriersStatus: IManualInteractionBarrierStatus[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        initialPFD: '3.18e-4',
        pfdManual: '3.18e-4',
        moc: '3.18e-4',
        responsible: 'Denis',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        initialPFD: '3.18e-4',
        pfdManual: '3.18e-4',
        moc: '3.18e-4',
        responsible: 'Denis',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const mandatoryBarriers: IMandatoryBarriers[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        safetyCritical: 'Bowtie Mandatory Barrier',
        responsible: 'Denis',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        barrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        safetyCritical: 'Bowtie Mandatory Barrier',
        responsible: 'Denis',
        date: 'dd/mm/aaaa às 00:00am'
    }
]

export const escalationFactorQualitativeBarriers: IEscalationFactorQualitativeBarriers[] = [
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        escalationFactorBarrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        effectiveness: 'Bowtie Mandatory Barrier',
        dc: 'Denis',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    },
    {
        resource: 'resource1',
        bowtieCode: 'bowtiecode',
        barrierId: 'BA001',
        escalationFactorBarrierName:
            'consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua consectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliquaconsectetur adipiscing elit, sed do eiusmod temporarium incididunt ut labore et dolore magna aliqua',
        effectiveness: 'Bowtie Mandatory Barrier',
        dc: 'Denis',
        status: 'Inactive',
        date: 'dd/mm/aaaa às 00:00am'
    }
]
